import { FC, forwardRef, HTMLAttributes, ReactNode } from "react"

import { cn } from "#Utils/cn"

interface BoxProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode
  className?: string
}

interface BoxHeaderProps {
  children?: ReactNode
  className?: string
}

interface BoxContentProps {
  noSpacing?: boolean
  className?: string
  children?: ReactNode
}

interface BoxFooterProps {
  children?: ReactNode
  className?: string
}

type BoxComponent = ReturnType<typeof forwardRef<HTMLDivElement, BoxProps>> & {
  Header: FC<BoxHeaderProps>
  Content: FC<BoxContentProps>
  Footer: FC<BoxFooterProps>
}

const Box = forwardRef<HTMLDivElement, BoxProps>(function Box(
  { className, children, ...props },
  ref,
) {
  return (
    <div ref={ref} className={cn("c-box", className)} {...props}>
      {children}
    </div>
  )
}) as BoxComponent

const Header: FC<BoxHeaderProps> = ({ children, className }) => {
  return <div className={cn("c-box__header", className)}>{children}</div>
}

const Content: FC<BoxContentProps> = ({ noSpacing = false, className, children }) => {
  return <div className={cn(className, !noSpacing && "px-5 py-4")}>{children}</div>
}

const Footer: FC<BoxFooterProps> = ({ children, className }) => {
  return <footer className={cn("c-box__footer", className)}>{children}</footer>
}

Box.Header = Header
Box.Content = Content
Box.Footer = Footer

export default Box
